function nearestPow2(aSize) {
    return Math.pow(2, Math.round(Math.log(aSize) / Math.log(2)));
}

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

export { nearestPow2, clamp };
